import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useUserPermissionList = () => {
  const [loading, setLoading] = useState(true);
  const [permissionList, setPermissionList] = useState([]);
  const [pageRef, setPageRef] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const getUserPermissionList = ({ Guid, Page, Count, onSuccess }) => {
    setLoading(true);

    axiosClient
      .get('SettingAccount/User/Permission/List', {
        params: { Guid, Page, Count },
      })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);

          setPermissionList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              id: element.permissionGuid,
              display: element.display,
            }));
            onSuccess?.();
            return { ...prev, [Page || 1]: orderedList };
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return {
    getUserPermissionList,
    loading,
    permissionList,
    pageRef,
  };
};

export default useUserPermissionList;
